import { useTranslation } from '@web_opxp/features';
import { FC } from 'react';
import ENV from '../../base/env';
import './FeedbackWidget.scss';

export interface IFeedbackWidgetProps {
  titleId?: string;
  onFeedback: (answer: 0 | 1) => void;
}

const FeedbackWidget: FC<IFeedbackWidgetProps> = ({ titleId = 'Exercise.PostWorkout.Survey.Title', onFeedback }) => {
  const { t } = useTranslation();

  return (
    <div className="feedback-widget">
      <h2 className="survey-title">{t(titleId)}</h2>
      <div className="workout-survey">
        <img
          className="survey-icon"
          alt="like"
          src={`${ENV.AssetsBaseUrl}/feature/icons/workout-survey/thumb-up.svg`}
          onClick={() => onFeedback(1)}
        />
        <img
          className="survey-icon"
          alt="don't like"
          src={`${ENV.AssetsBaseUrl}/feature/icons/workout-survey/thumb-down.svg`}
          onClick={() => onFeedback(0)}
        />
      </div>
    </div>
  );
};
export default FeedbackWidget;
